module.exports = __webpack_public_path__ + "img/x-mark.082519b9.svg";